import { render, staticRenderFns } from "./Present.vue?vue&type=template&id=7ae70db0&scoped=true&lang=pug&"
import script from "./Present.vue?vue&type=script&lang=js&"
export * from "./Present.vue?vue&type=script&lang=js&"
import style0 from "./Present.vue?vue&type=style&index=0&id=7ae70db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae70db0",
  null
  
)

export default component.exports